export const ActionTypes = {
  LOADING: "ASSIGN_CRITERIA_LOADING",
  ERROR: "ASSIGN_CRITERIA_ERROR",
  SUCCESS: "ASSIGN_CRITERIA_SUCCESS",
};
